<div class="container-fluid refaccountsContent">
    <nav>
        <div class="nav nav-tabs  bg-light" id="nav-tab" role="tablist">
                <!-- <a class="nav-item nav-link active pointer" id="nav-all-tab" data-toggle="tab" role="tab" aria-controls="nav-all" aria-selected="false" (click)="toggleTab('1', 'nav-all','nav-all-tab')">Toutes les demandes</a> -->
            <a class="nav-item nav-link active pointer" id="nav-all-tab" data-toggle="tab" role="tab" aria-controls="nav-all" aria-selected="false"></a>
        </div>
    </nav>
        <div class="tab-content  bg-light refContent" id="nav-tabContent">
        <div class="row  bg-light noMargin">
            <div class="col-6">
            <mat-form-field class="ml-2">
                <mat-label>{{'accountChoice.rechercher'|translate}}</mat-label>
                <input matInput (keyup)="applyFilter($event.target.value)">
            </mat-form-field> 
            </div>
            <div class="col-6">
            <!-- <div class="text-right"> <i  aria-hidden="true" (click)="refreshTab()" class="fas fa-sync  fa-1-2x p-2" style="color:steelblue; cursor:pointer;"></i> </div> -->
            </div>
        </div>
        <!-- STATUS 1 -->
        <div class="tab-pane noOverflow fade show active" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
            <mat-table class="table lstdossier bg-white table-hover" matSort [dataSource]="dataSource" (matSortChange)="sortScale($event,'1')">
            <!-- Champs Status -->
            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span [translate]="'activlist.statut'"> </span></mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <div  *ngIf="res.accepted == 0" matTooltip="{{'accountChoice.requestInProcess'|translate}}">
                           <i  aria-hidden="true" class="far fa-user-clock fa-1-2x waiting mr-2"></i> 
                        </div>
                        <div  *ngIf="res.accepted == 1"  matTooltip="{{'accountChoice.requestAccepted'|translate}}">
                            <i  aria-hidden="true" class="far fa-user-check fa-1-2x success mr-2"></i> 
                         </div>
                        <div  *ngIf="res.accepted == 2"   matTooltip="{{'accountChoice.requestRefused'|translate}}">
                          <i  aria-hidden="true" class="far fa-user-times fa-1-2x refused mr-2"></i> 
                        </div>
                </mat-cell>
            </ng-container>
            <!-- Champs Mail -->
            <ng-container matColumnDef="mail">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span [translate]="'scaleform.mail'"> </span></mat-header-cell>
                <mat-cell  *matCellDef="let res">
                   <span  class="text-center"> {{res.mail}} </span> 
                </mat-cell>
            </ng-container>
            <!-- Champs Nom -->
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span [translate]="'scaleform.nom'"></span> </mat-header-cell>
                <mat-cell *matCellDef="let res"  class="text-center">{{res.name}}</mat-cell>
            </ng-container>
            <!-- Champs Prénom -->
            <ng-container matColumnDef="firstname">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span [translate]="'scaleform.prenom'" ></span></mat-header-cell>
                <mat-cell *matCellDef="let res"  class="text-center">{{res.firstname}}</mat-cell>
            </ng-container>
            <!-- Champs Ligne fixe -->
            <ng-container matColumnDef="phone">
                <mat-header-cell *matHeaderCellDef mat-sort-header > <span [translate]="'scaleform.telephone'" ></span></mat-header-cell>
                <mat-cell *matCellDef="let res"  class="text-center">{{res.phone}}</mat-cell>
            </ng-container>
            <!-- Champs Date d'activation -->
            <ng-container matColumnDef="mobilePhone">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span  [translate]="'scaleform.mobile'"> </span></mat-header-cell>
                <mat-cell *matCellDef="let res"  class="text-center">{{res.mobilePhone}}</mat-cell>
            </ng-container>
            <!-- Champs Utilisateur -->
            <ng-container matColumnDef="socialReason">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span [translate]="'scaleform.raisonsociale'"></span></mat-header-cell>
                <mat-cell *matCellDef="let res"  class="text-center">{{res.socialReason}}</mat-cell>
            </ng-container>
            <!-- Champs Nom utilisateur -->
            <ng-container matColumnDef="address">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span  [translate]="'scaleform.adresse'"></span></mat-header-cell>
                <mat-cell *matCellDef="let res"  class="text-center"> {{res.address}} </mat-cell>
            </ng-container>
            <!-- Champs Compagnie utilisateur -->
            <ng-container matColumnDef="postalCode">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span  [translate]="'scaleform.codepostal'"></span></mat-header-cell>
                <mat-cell *matCellDef="let res"  class="text-center">{{res.postalCode}}</mat-cell>
            </ng-container>
            <!-- Champs  Payeur -->
            <ng-container matColumnDef="city">
                <mat-header-cell *matHeaderCellDef mat-sort-header ><span [translate]="'scaleform.ville'"></span></mat-header-cell>
                <mat-cell *matCellDef="let res"  class="text-center">{{res.city}}</mat-cell>
            </ng-container>
            <!-- Champs Compagnie Payeur -->
            <ng-container matColumnDef="country">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span  [translate]="'scaleform.pays'"></span></mat-header-cell>
                <mat-cell *matCellDef="let res"  class="text-center">{{res.country}}</mat-cell>
            </ng-container>
            <!-- Champs Motif du refus -->
            <ng-container matColumnDef="refus">
                <mat-header-cell *matHeaderCellDef mat-sort-header [translate]="'scaleform.motif'"></mat-header-cell>
                <mat-cell *matCellDef="let res" class="text-center">{{res.refusal}}</mat-cell>
            </ng-container>
            <!-- Champs Motif du refus -->
            <ng-container matColumnDef="info">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="text-center ">+</mat-header-cell>
                <mat-cell *matCellDef="let res" class="pointer text-center"><i  aria-hidden="true" class="far fa-eye mr-2 " (click)="displayInfoModal(res.idcolorUser);"></i></mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            </mat-table>
        </div> 
    </div>
</div>

<!-- Modal d'information -->
<div id="modalInfo" class="modal">
    <div class="modal-content" >
        <span class="text-right close pointer" (click)="closeModal();">  <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
        <h1 class="text-center"  [translate]="'accountChoice.infosupp'"></h1>
        <div>
            <div *ngFor="let coloruser of actualcoloruser"  class="row mx-auto ">
                <div class="col-lg-8  mx-auto">
                    <hr>
                    <h3>  
                        <i  aria-hidden="true" class="fad fa-hand-receiving mr-2"  style="--fa-primary-color: #3a2785; --fa-secondary-color: #0177be;"></i> 
                        <span  [translate]="'scaleform.utilisateur'"></span>
                    </h3>
                    <div class="row">
                        <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.nom'" ></span> : {{ coloruser.name }}</div>
                        <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.prenom'"></span> : {{ coloruser.firstname }}</div>
                        <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.telephone'"></span> : {{ coloruser.phone }}</div>
                        <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.mail'"></span> : {{ coloruser.mail }}</div>
                        <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.mobile'"></span> : {{ coloruser.mobilePhone }}</div>
                    </div>
                </div>
                <div class="col-lg-8 mx-auto">
                    <hr>
                    <h3> 
                        <i  aria-hidden="true" class="fad fa-industry-alt mr-2"  style="--fa-primary-color: #3a2785; --fa-secondary-color: #0177be;"></i> 
                        <span [translate]="'activlist.compagnieutilisateur'"></span>
                    </h3>
                    <div class="row">
                        <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.raisonsociale'"> </span> : {{ coloruser.socialReason }}</div>
                        <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.adresse'"> </span> : {{ coloruser.address }}</div>
                        <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.codepostal'"> </span> : {{ coloruser.postalCode }}</div>
                        <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.ville'"> </span> : {{ coloruser.city }}</div>
                        <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.pays'"> </span> : {{ coloruser.country }}</div>
                    </div>
                </div>
                <div *ngIf="coloruser.businessCode || coloruser.customerCode" class="col-lg-8  mx-auto">
                    <hr>
                    <h3> 
                        <i  aria-hidden="true" class="fad fa-info-circle mr-2"  style="--fa-primary-color: #3a2785; --fa-secondary-color: #0177be;"></i> 
                        <span> Informations supplémentaires</span>
                    </h3>
                    <div class="col-8" *ngIf="coloruser.businessCode"> <span class="font-weight-bold"> Ville du RRG ou du concessionnaire </span> : {{ coloruser.businessCode }}</div>
                    <div class="col-8" *ngIf="coloruser.customerCode"> <span class="font-weight-bold"> Numéro de compte MPR </span> : {{ coloruser.customerCode }}</div>
                </div>
                <div *ngIf="coloruser.refusal" class="col-lg-8 mx-auto">
                    <hr>
                    <h3>
                        <i  aria-hidden="true" class="fad  fa-comment-alt-lines mr-2"  style="--fa-primary-color: #3a2785; --fa-secondary-color: #0177be;"></i> 
                        <span [translate]="'accountChoice.motif'"></span>
                    </h3>
                    <div class="col-lg-6">
                        {{coloruser.refusal}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
